// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__PMmSF","alertIcon":"ConfirmModal_alertIcon__1knHf"};